export default __webpack_public_path__ + "static/topic25-52555361cc190a4101c2f4cf6a779687.png";